module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-SemiBold-WebXL-b63301fceeb24e52fdf86d5494a85b25.woff2";